/* eslint-disable no-restricted-imports */
import { createSelectorCreator } from 'reselect';
import { IntervalMapCache } from '@anwhy/reselect-utils';
import { ChainSelectorOptions } from '@cbridge-utils/redux';
import { defaultSelectorCreator } from './_helpers/defaultSelectorCreator';

export const createDefaultCachedSelectorOptions = () => {
  return {
    selectorCreator: defaultSelectorCreator,
    cacheObject: new IntervalMapCache(),
  };
};

export const defaultChainSelectorOptions: ChainSelectorOptions<typeof createSelectorCreator> = {
  createSelectorOptions: createDefaultCachedSelectorOptions,
};
